import { render, staticRenderFns } from "./PubAPITrans.vue?vue&type=template&id=61456e65&"
import script from "./PubAPITrans.vue?vue&type=script&lang=js&"
export * from "./PubAPITrans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports